import { render, staticRenderFns } from "./right_classify.vue?vue&type=template&id=c1180c78&scoped=true"
import script from "./right_classify.vue?vue&type=script&lang=js"
export * from "./right_classify.vue?vue&type=script&lang=js"
import style0 from "./right_classify.vue?vue&type=style&index=0&id=c1180c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1180c78",
  null
  
)

export default component.exports